<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="12" >
            <a-form-item :label="$t('label.diseaseFileCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled='isCodeDisabled' v-decorator="['diseaseCode', validatorRules.diseaseCode]" :placeholder="$t('label.pleaseEnterTheDiseaseFileCode')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item :label="$t('label.diseaseFileDescription')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['diseaseName', validatorRules.diseaseName]" placeholder="请输入疾病档案描述"></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('diseaseName')" :popLists="getMainTablePop('diseaseName')">
                <a-input
                  v-decorator="['diseaseName', validatorRules.diseaseName]"
                  :read-only="whetherLang('diseaseName')"
                  @click="isLangClick('diseaseName', false)"
                  :placeholder="$t('label.pleaseEnterADiseaseFileDescription')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item :label="$t('label.associatedDiseaseCategories')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['categoryCode']" :trigger-change="true" dictCode="jbfl" :placeholder="$t('label.pleaseSelectTheCategoryOfAssociationFromTheDataDictionaryClassificationOfDiseaseFiles')" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['validFlag',{'initialValue': 'Y'}]" :trigger-change="true" dictCode="sfyx"  :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.associatedDiseaseDescription')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-textarea v-decorator="['buffer1']" rows="4" placeholder="请输入疾病说明\描述"/> -->
              <mtc-lang-popover :whetherLang="whetherLang('buffer1')" :popLists="getMainTablePop('buffer1')">
                <a-textarea
                  v-decorator="['buffer1']"
                  :read-only="whetherLang('buffer1')"
                  @click="isLangClick('buffer1', false)"
                  :placeholder="$t('label.pleaseEnterADiseaseDescription')"
                ></a-textarea>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
      <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane :tab="$t('tabName.symptoms')" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :tableName="subTable[0]"
          :loading="efsMdSymptomTable.loading"
          :columns="efsMdSymptomTable.columns"
          :dataSource="efsMdSymptomTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="true"
          @valueChange="handleValueChange"/>
      </a-tab-pane>
      <a-tab-pane :tab="$t('tabName.visceralAnatomy')" :key="refKeys[1]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[1]"
          :tableName="subTable[1]"
          :loading="efsMdVisceraTable.loading"
          :columns="efsMdVisceraTable.columns"
          :dataSource="efsMdVisceraTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="true"
          @valueChange="handleValueChange"/>
      </a-tab-pane>
      <a-tab-pane :tab="$t('tabName.treatmentOptions')" :key="refKeys[2]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[2]"
          :tableName="subTable[2]"
          :loading="efsMdTreatmentTable.loading"
          :columns="efsMdTreatmentTable.columns"
          :dataSource="efsMdTreatmentTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="true"
          @valueChange="handleValueChange"/>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { FormTypes,getRefPromise } from '@/utils/JEditableTableUtil'
  import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import { getSymptomByCode ,getVisceraByCode,getTreatmentByCode} from '@api/api'

  export default {
    name: 'EfsMdDiseaseForm',
    mixins: [JEditableTableMixin],
    components: {
      JFormContainer,
      JDictSelectTag,
    },
    data() {
      return {
        mainTable: 'efs_md_disease',
        subTable: ['efs_md_symptom', 'efs_md_viscera', 'efs_md_treatment'],
        isCodeDisabled: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {
          diseaseCode: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheDiseaseFileCode')},
            ]
          },
          diseaseName: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterADiseaseFileDescription')},
            ]
          },
        },
        refKeys: ['efsMdSymptom', 'efsMdViscera', 'efsMdTreatment', ],
        tableKeys:['efsMdSymptom', 'efsMdViscera', 'efsMdTreatment', ],
        activeKey: 'efsMdSymptom',
        // 症状
        efsMdSymptomTable: {
          loading: false,
          tableName: 'efs_md_symptom',
          dataSource: [],
          columns: [
            // {
            //   title: '症状档案',
            //   key: 'symptomCode',
            //   type: FormTypes.select,
            //   dictCode:"efs_md_archives,name,code,arch_type='110' and valid_flag='Y'",
            //   width:"200px",
            //   placeholder: '请输入${title}',
            //   defaultValue: '',
            // },
            {
              title: this.$t('tableHeader.symptomProfile'),
              key: 'symptomCode',
              type: FormTypes.select,
              width:"200px",
              placeholder: this.$t('tip.pleaseSelect') + '${title}',
              dictCode:"efs_md_archives,name,code,arch_type='110' and valid_flag='Y'",
              // validateRules: [
              //   {
              //     required: true, // 必填
              //     message: '请选择${title}' // 提示的文本
              //   }
              // ]
            },
            {
              title: this.$t('tableHeader.symptomProfile'),
              key: 'symptomName',
              width: "100px",
              type: FormTypes.hidden,
            },
            {
              title: this.$t('tableHeader.symptomDescription'),
              key: 'symptomDescription',
              width: "900px",
              type: FormTypes.normal,
            },
          ]
        },
        // 脏器解剖
        efsMdVisceraTable: {
          loading: false,
          tableName: 'efs_md_viscera',
          dataSource: [],
          columns: [
            {
              title: this.$t('tableHeader.visceralAnatomyProfile'),
              key: 'visceraCode',
              type: FormTypes.select,
              dictCode:"efs_md_archives,name,code,arch_type='120' and valid_flag='Y'",
              width:"200px",
              placeholder: this.$t('tip.pleaseSelect') + '${title}',
              defaultValue: '',
            },
            {
              title: this.$t('tableHeader.organAnatomyName'),
              key: 'visceraName',
              width: "100px",
              type: FormTypes.hidden,
            },
            {
              title: this.$t('tableHeader.organAnatomyDescription'),
              key: 'visceraDescription',
              width: "900px",
              type: FormTypes.normal,
            },
          ]
        },
        // 治疗方案
        efsMdTreatmentTable: {
          loading: false,
          tableName: 'efs_md_treatment',
          dataSource: [],
          columns: [
            {
              title: this.$t('tableHeader.treatmentPlanFile'),
              key: 'treatmentCode',
              type: FormTypes.select,
              dictCode:"efs_md_archives,name,code,arch_type='50' and valid_flag='Y'",
              width:"200px",
              placeholder: this.$t('tip.pleaseSelect') + '${title}',
              defaultValue: '',
            },
            {
              title: this.$t('tableHeader.treatmentProtocolName'),
              key: 'treatmentName',
              width: "100px",
              type: FormTypes.hidden,
            },
            {
              title: this.$t('tableHeader.treatmentProtocolDescription'),
              key: 'treatmentDescription',
              width: "900px",
              type: FormTypes.normal,
            },
          ]
        },
        url: {
          add: "/diseaseArchive/efsMdDisease/add",
          edit: "/diseaseArchive/efsMdDisease/edit",
          queryById: "/diseaseArchive/efsMdDisease/queryById",
          efsMdSymptom: {
            list: '/diseaseArchive/efsMdDisease/queryEfsMdSymptomByMainId'
          },
          efsMdViscera: {
            list: '/diseaseArchive/efsMdDisease/queryEfsMdVisceraByMainId'
          },
          efsMdTreatment: {
            list: '/diseaseArchive/efsMdDisease/queryEfsMdTreatmentByMainId'
          },
        }
      }
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：false流程表单 true普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      addBefore(){
        this.form.resetFields()
        this.efsMdSymptomTable.dataSource=[]
        this.efsMdVisceraTable.dataSource=[]
        this.efsMdTreatmentTable.dataSource=[]
      },
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter() {
        let fieldval = pick(this.model,'diseaseCode','diseaseName','categoryCode','buffer1','validFlag')
        this.$nextTick(() => {
          console.log('fieldVal----', this.model)
          this.form.setFieldsValue(fieldval)
        })
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.isCodeDisabled = true;

          /*     this.requestSubTableData(this.url.efsMdSymptom.list, params, this.efsMdSymptomTable)
               this.requestSubTableData(this.url.efsMdViscera.list, params, this.efsMdVisceraTable)
               this.requestSubTableData(this.url.efsMdTreatment.list, params, this.efsMdTreatmentTable)*/
            setTimeout(()=>this.requestSubTableData(this.url.efsMdSymptom.list, params, this.efsMdSymptomTable),10)
            setTimeout(()=>this.requestSubTableData(this.url.efsMdViscera.list, params, this.efsMdVisceraTable),10)
            setTimeout(()=>this.requestSubTableData(this.url.efsMdTreatment.list, params, this.efsMdTreatmentTable),10)
        }else{
          this.isCodeDisabled = false;
        }
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          efsMdSymptomList: allValues.tablesValue[0].values,
          efsMdVisceraList: allValues.tablesValue[1].values,
          efsMdTreatmentList: allValues.tablesValue[2].values,
        }
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          })
        }
      },
      validateError(msg){
        this.$message.error(msg)
      },
     popupCallback(row){
       this.form.setFieldsValue(pick(row,'diseaseCode','diseaseName','categoryCode','buffer1','validFlag'))
     },
      // getSubTableSubData(data) {
      //   let newDataSource = data
      //   if (newDataSource && newDataSource.length) {
      //     newDataSource.map(item => {
      //       item.code = this.emptySelect(item.name);
      //       item.description = this.emptyShow(item.description)
      //     })
      //   }
      //   this.efsMdSymptomTable.dataSource = newDataSource
      // },
      handleValueChange(event) {
        if(event.column.key === 'symptomCode') {
          getSymptomByCode({ symptomCode: event.row.symptomCode}).then(res => {
            if (res.success) {
              this.$refs.efsMdSymptom.setValues([{
                rowKey: event.row.id,
                values: {
                  symptomName: res.result.name,
                  symptomDescription: res.result.description,
                }
              }]);
              this.$refs.efsMdSymptom.$forceUpdate();
            }
          });
        } else if(event.column.key === 'visceraCode') {
          getVisceraByCode({ visceraCode: event.row.visceraCode}).then(res => {
            if (res.success) {
              this.$refs.efsMdViscera.setValues([{
                rowKey: event.row.id,
                values: {
                  visceraName: res.result.name,
                  visceraDescription: res.result.description,
                }
              }]);
              this.$refs.efsMdViscera.$forceUpdate();
            }
          });
        }else if(event.column.key === 'treatmentCode') {
          getTreatmentByCode({ treatmentCode: event.row.treatmentCode}).then(res => {
            if (res.success) {
              this.$refs.efsMdTreatment.setValues([{
                rowKey: event.row.id,
                values: {
                  treatmentName: res.result.name,
                  treatmentDescription: res.result.description,
                }
              }]);
              this.$refs.efsMdTreatment.$forceUpdate();
            }
          });
        }
      },

    }
  }
</script>

<style scoped>
</style>